import { Instance, applySnapshot, flow, types } from 'mobx-state-tree';

import { updateProgramGroupsChannelsSettings } from '@common/api/curators';
import CuratorProgramGroup, {
	ICuratorProgramGroupModel,
} from '@common/models/CuratorGroups/CuratorProgramGroup';

function normalizeCuratorProgramGroupSnapshot(raw: any) {
	return {
		id: Number(raw.id),
		program_group_id: Number(raw.program_group_id),

		has_group_channels: Boolean(raw.has_group_channels),
		has_group_channels_teacher: Boolean(raw.has_group_channels_teacher),
		has_channel_channels: Boolean(raw.has_channel_channels),
		has_channel_channels_teacher: Boolean(raw.has_channel_channels_teacher),
		has_messaging_channels: Boolean(raw.has_messaging_channels),

		created_at: raw.created_at,
		updated_at: raw.updated_at,
	};
}

const Program = types.model('Program', {
	id: types.maybe(types.number),
	name: types.string,
});

const ProgramGroup = types
	.model('ProgramGroup', {
		id: types.identifierNumber,
		name: types.string,
		group_id: types.maybe(types.number),
		program_id: types.maybe(types.number),
		students_count: types.number,

		program: types.maybeNull(Program),
		curator_program_group: types.maybeNull(CuratorProgramGroup),
	})
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		updateProgramGroupsChannelsSettings: flow(function* (data: ICuratorProgramGroupModel) {
			self.loading = true;
			try {
				const result = yield updateProgramGroupsChannelsSettings(self.id, data);
				const normalized = normalizeCuratorProgramGroupSnapshot(result);

				if (!self.curator_program_group) {
					self.curator_program_group = CuratorProgramGroup.create(normalized);
				} else {
					applySnapshot(self.curator_program_group, normalized);
				}
			} finally {
				self.loading = false;
			}
		}),
	}));

export default ProgramGroup;

export interface IProgramGroupModel extends Instance<typeof ProgramGroup> {}
export interface IProgramModel extends Instance<typeof Program> {}
